import { boot } from "quasar/wrappers";
import axios from "axios";

import useRoutes from "boot/routes";

const { routes } = useRoutes();

import { LocalStorage } from "quasar";
let isRefreshing = false;
let count = 0;
// Be careful when using SSR for cross-request state pollution
// due to creating a Singleton instance here;
// If any client changes this (global) instance, it might be a
// good idea to move this instance creation inside of the
// "export default () => {}" function below (which runs individually
// for each client)
const api = axios.create({ baseURL: process.env.API_URL });

export default boot(({ app, router, store }) => {
  // for use inside Vue files (Options API) through this.$axios and this.$api
  app.config.globalProperties.$axios = axios;
  // ^ ^ ^ this will allow you to use this.$axios (for Vue Options API form)
  //       so you won't necessarily have to import axios in each vue file
  let urlParams = window.location;
  let originalRequestList = [];
  let inThrottle = false;
  api.interceptors.request.use(
    (config) => {
      if (config.url.includes("traders")) return config;
      let token;
      if (urlParams.search.includes("token=")) {
        LocalStorage.set("token", urlParams.search.split("token=")[1]);
        token = urlParams.search.split("token=")[1];
      }
      // Do something before request is sent
      if (!urlParams.search.includes("token=")) {
        token = LocalStorage.getItem("token")?.access;
      }

      if (token == undefined) {
        token = LocalStorage.getItem("token");
      }
      if (token) {
        config.headers.Authorization = `Bearer ${token}`;
      }


      return config;
    },
    (error) => {
      // Do something with request error
      return Promise.reject(error);
    }
  );

  api.interceptors.response.use(
    (response) => response,
    (error) => {
      const status = error.response?.status;
      const originalRequest = error.config;
      if (originalRequest?.url === "/authenticate/v2/token/refresh/") {
        store.dispatch("authenticate/purgeToken");
        router.push("/login");
        return Promise.reject(error);
      }
      if (originalRequest?.url === "/authenticate/v2/token/refresh/")
        LocalStorage.remove("validatingOtp");

      let responseStatus;

      if (error?.response?.data?.code === "token_not_valid")
        responseStatus = 401;

      if (status != 401 && responseStatus != 401) return Promise.reject(error);
      let refresh = LocalStorage.getItem("token")?.refresh;
      count++;

      if (refresh == undefined) {
        refresh = LocalStorage.getItem(
          "token",
          urlParams.hash.split("token=")[2]
        );
      }

      if (!isRefreshing) {
        isRefreshing = true;
        if (store.state.authenticate.isAuthenticated) {
          const refreshingCall = store
            .dispatch("authenticate/refresh", {
              refreshToken: refresh,
            })
            .then(({ access }) => {
              store.commit("authenticate/setRefreshingState", null);
              store.commit("authenticate/setRefreshingCall", null);
            })

            .catch((error) => {
              return Promise.reject(error);
            });
          store.commit("authenticate/setRefreshingCall", refreshingCall);
          store.commit("authenticate/setRefreshingState", true);
          return refreshingCall;
        }
      }
      if (originalRequest.url !== "/authenticate/v2/token/refresh/") {
        if ((responseStatus === 401 || status === 401) && count > 30) {
          return Promise.reject(error);
        }
        return api.request(originalRequest);
      }
    }
  );

  app.config.globalProperties.$api = api;
  // ^ ^ ^ this will allow you to use this.$api (for Vue Options API form)
  //       so you can easily perform requests against your app's API
});

export { api };
